export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./player-activity.vue?vue&type=template&id=46d09638"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/view/player-activity.vue?vue&type=template&id=46d09638
// module id = 4Sb1
// module chunks = 0